import { useMutation } from 'react-query';

import { deleteContract as mutationFn } from 'api/endPoints/deleteContract';

export const useMutationDeleteSubProgram = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    id: number;
}
